import { ComponentProps } from "react";
import { CardProps, Flex, Spin } from "antd";
import LoadingOutlined from "@ant-design/icons/LoadingOutlined";

import { AuthLogo } from "@components/Auth/Logo";
import { AuthTheme } from "@components/Auth/Theme";

import { StyledCard } from "./styles";

type AuthCardProps = CardProps & {
  showLogo?: boolean;
  loading?: boolean;
  logoProps?: ComponentProps<"div">;
};

export const AuthCard = ({
  showLogo,
  loading,
  logoProps,
  children,
  ...props
}: AuthCardProps) => {
  return (
    <AuthTheme>
      <StyledCard {...props}>
        <Flex vertical gap={24}>
          {showLogo && <AuthLogo {...logoProps} />}

          {loading && (
            <Flex align="center" justify="center" style={{ height: 100 }}>
              <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} />} />
            </Flex>
          )}

          {!loading && <div>{children}</div>}
        </Flex>
      </StyledCard>
    </AuthTheme>
  );
};
